var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFileIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 602 602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.93,21C486.52,7.51,468.27-.05,449.26,0h-148.26c-39.56.05-71.62,32.11-71.67,71.67v344c.05,39.56,32.11,71.62,71.67,71.67h229.33c39.56-.04,71.62-32.1,71.67-71.67V152.75c.06-19.02-7.5-37.28-21-50.68l-81.07-81.07ZM458.66,29.82c7.94,1.77,15.21,5.73,21,11.45l81.07,81.07c5.75,5.76,9.73,13.05,11.48,21h-70.55c-23.74-.03-42.97-19.26-43-43V29.82ZM573.33,415.67c-.03,23.74-19.26,42.97-43,43h-229.33c-23.74-.03-42.97-19.26-43-43V71.67c.03-23.74,19.26-42.97,43-43h129v71.67c.04,39.56,32.1,71.62,71.67,71.67h71.67v243.67ZM0,530.33V186.33c.05-39.56,32.11-71.62,71.67-71.67h114.67v28.67h-114.67c-23.74.03-42.97,19.26-43,43v344c.03,23.74,19.26,42.97,43,43h229.33c23.74-.03,42.97-19.26,43-43h28.67c-.04,39.56-32.1,71.62-71.67,71.67H71.67c-39.56-.05-71.62-32.11-71.67-71.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFileIconBlack);
export default __webpack_public_path__ + "static/media/CopyFileIcon_Black.e27b5397719b3ee2549ba9ced73a7447.svg";
export { ForwardRef as ReactComponent };